export class ForgotPassword {
    email: string;
}

export class ResetPassword {
    resetToken: string;
    password: string;
    confirmPassword: string;
}